import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Args {
  roomId: string;
}

export interface RawResult {
  rentRoom: boolean;
}

export const rentRoom = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      roomId: args.roomId
    },
    update(_proxy, data): boolean {
      return data.data!.rentRoom;
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
